import { render } from "./TopBarSystemNotificationsCard.vue?vue&type=template&id=6aa2b8fa&scoped=true"
import script from "./TopBarSystemNotificationsCard.vue?vue&type=script&lang=js"
export * from "./TopBarSystemNotificationsCard.vue?vue&type=script&lang=js"

import "./TopBarSystemNotificationsCard.vue?vue&type=style&index=0&id=6aa2b8fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa2b8fa"]])

export default __exports__